const required = (name: string): string => {
  const value = import.meta.env[name] as string | undefined;
  if (!value) throw new Error(`Missing environment variable: ${name}`);
  return value;
};

export const config = {
  supabaseUrl: required('VITE_SUPABASE_URL'),
  supabasePublishableKey: required('VITE_SUPABASE_PUBLISHABLE_KEY'),
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/api',
  timezone: 'Asia/Colombo',
};
